import { injectable } from 'tsyringe'
import { BulletinReportApiRepository } from '@/app/repositories/api/BulletinReportApiRepository'
import { BulletinReport, Export } from '@/domain/entities/BulletinReport'

@injectable()
export class BulletinReportPresenter {
  private repository: BulletinReportApiRepository

  constructor(repository: BulletinReportApiRepository) {
    this.repository = repository
  }

  public loadBulletinReport(params: Object): Promise<BulletinReport> {
    return this.repository.getAll(params)
  }
  public loadExport(params: Object): Promise<Export> {
    return this.repository.getExport(params)
  }
}
